import { render, staticRenderFns } from "./CalendarioEnfermeras.vue?vue&type=template&id=22fd0ea4&scoped=true&"
import script from "./CalendarioEnfermeras.vue?vue&type=script&lang=js&"
export * from "./CalendarioEnfermeras.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioEnfermeras.vue?vue&type=style&index=0&id=22fd0ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd0ea4",
  null
  
)

export default component.exports